export const ingredients = [
  {
    id: 'main',
    items: [
      {
        name: 'Unsweetened dried coconut',
        preparation: 'shredded',
        number: 1,
        unit: 'cup',
        numberMetric: 85,
        unitMetric: 'g'
      },
      {
        name: 'Medjool dates',
        preparation: 'pitted',
        number: 10
      },
      {
        name: 'Dark chocolate chips',
        number: 0.3,
        unit: 'cups',
        numberMetric: 60,
        unitMetric: 'g'
      },
      {
        name: 'Coconut oil',
        number: 0.5,
        unit: 'tsp'
      },
    ]
  }
]